export default __webpack_public_path__ + "static/media/2.14b28c8f.jpg";